import { createContext, useContext } from 'react';

import { ToastProps } from './Toast';

type ToastContextType = {
  showToast: (toast: ToastProps) => void;
};

export const ToastContext = createContext<ToastContextType>({
  showToast: () => {
    // empty
  },
});

export const useToast = (): ToastContextType => useContext(ToastContext);
